import createReducer from '../utils/createReducer';
import {
  SALES_CHART_TYPES_REQUEST,
  SALES_CHART_TYPES_FAILURE,
  SALES_CHART_TYPES_SUCCESS,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [SALES_CHART_TYPES_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [SALES_CHART_TYPES_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [SALES_CHART_TYPES_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/salesChartTypes.js